import {
    GET_APPLICATION_DOCUMENTS,
    get_headers,
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';
import axios from 'axios';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import $ from 'jquery';
import FilePreviewComponent from '@/components/probaworkflows_base_components/FilePreviewComponent/FilePreviewComponent.vue';


export default {
    name: 'EntityDocuments',
    mixins: [alert_mixin, formatting_mixins],
    components: { FilePreviewComponent },
    data: () => ({
        headers: get_headers(),
        documents: [],
        table_safe_documents: [],
        preview_url: null,
        preview_modal: false,

    }),
    mounted() {
        this.application_id = sessionStorage.getItem('application_id');
        if (this.application_id) {
            this.get_documents();
        }
    },


    watch: {
        profile_role_form_id(newVal) {
            if (newVal) {
                this.get_documents();
            }
        }
    },


    methods: {


        destroy_data_table() {
            if (this.dataTable) {
                this.dataTable.destroy();
                this.dataTable = null;
            }
        },

        close_the_file_preview() {
            this.preview_modal = false;
            // Optional: reset the preview_url if needed
            this.preview_url = null;
        },


        get_documents() {
            this.destroy_data_table();
            this.documents = [];
            axios.get(GET_APPLICATION_DOCUMENTS, {
                headers: this.headers,
                params: { application_id: this.application_id }
            })
                .then(response => {
                    const parsed_response = response.data;
                    if (parsed_response.data && parsed_response.data.length > 0) {
                        this.documents = parsed_response.data;
                        this.transform_documents_data();
                    } else {
                        this.documents = [];
                    }
                })
                .catch(error => {
                    this.show_error("Error loading documents: " + (error.response?.data?.message || error.message));
                });
        },


        initialize_data_table() {
            this.$nextTick(() => {
                const table_id = '#document_management_table';
                const table = $(table_id);

                if (table.length === 0) {
                    return;
                }

                if ($.fn.DataTable.isDataTable(table)) {
                    table.DataTable().clear().destroy();
                }

                this.dataTable = table.DataTable({
                    responsive: true,
                    autoWidth: false,
                    pageLength: 10
                });
            });
        },

        transform_documents_data() {
            if (this.documents.length > 0) {
                const TABLE_DOC_DATA = this.documents.map((document, index) => ({
                    no: index + 1,
                    file_name: document.file_name,
                    section: document.section,
                    submitted_on: document.submitted_on,
                    presigned_url: document.presigned_url,
                    status: document.is_verified ? 'Verified' : 'Pending Verification',
                    is_verified: document.is_verified,
                    verification_comment: document.verification_comment,
                    date_verified: this.format_date(document.date_verified),
                    section_question_id: document.section_question_id,
                }));

                this.table_safe_documents = TABLE_DOC_DATA;
            } else {
                this.table_safe_documents = [];
            }

            this.$nextTick(() => {
                this.initialize_data_table();
            });
        },



        preview_file(presigned_url) {
            if (!presigned_url) {
                this.show_error("Preview URL is missing.");
                return;
            }

            this.preview_url = presigned_url;
            this.preview_modal = true;

        },
        download_file(url, file_name) {
            if (!url) {
                this.show_error("Download URL is missing.");
                return;
            }

            const downloadUrl = url

            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', file_name || 'document.pdf');
            link.setAttribute('target', '_blank');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

    }
};
